import { Component } from '@angular/core';

@Component({
    selector: 'gl-seutulippu-page',
    templateUrl: './seutulippu-page.component.html'
})
export class SeutulippuPageComponent {}
